<template>
    <div class="info base-info">
        <div class="label-box">
        <div class="label"  @click="popupHandle('registerArea')">
            <div class="lable-left" style="width:111px">注册地区<span class="required-star">*</span></div>
            <div class="lable-right base-right">
                <span v-if="!areaName" class="placeholder right-style">请选择</span>
                <span class="right-style" v-else>{{areaName}}</span>
                <span class="iconfont right-icon">&#xe6aa;</span></div>
        </div>
        <div class="label"  @click="popupHandle('category')">
            <div class="lable-left" style="width:111px">所属领域<span class="required-star">*</span></div>
            <div class="lable-right base-right">
                <span v-if="!categoryVal" class="placeholder right-style-area" >请选择</span>
                <span class="category-text ellipsis right-style-area" v-else >{{categoryVal}}</span>
                <span class="iconfont right-icon">&#xe6aa;</span></div>
        </div>
        <div class="label"  @click="popupHandle('date')">
            <div class="lable-left" style="width:111px">成立日期</div>
            <div class="lable-right base-right">
                <span v-if="!date" class="placeholder right-style">请选择</span>
                <span class="right-style" v-else >{{date}}</span>
                <span class="iconfont right-icon">&#xe6aa;</span></div>
        </div>
        <div class="label lable-last" @click="popupHandle('highIndustry')">
            <div class="lable-left" style="width:230px">是否在有效期内的国高新资质</div>
            <div class="lable-right base-right select-box">
                <span class="placeholder select-input-arrow"  v-if="!industryText">请选择</span>
                <span class="select-input-arrow" v-else >{{industryText}}</span>
                <span class="iconfont right-icon">&#xe6aa;</span></div>
        </div>
        </div>
        <van-popup v-model="isShowRegister" round position="bottom" class="popup-box" :style="{ height: '580px' }" :closeable="true" close-icon-position="top-left" :afe-area-inset-bottom="true">  
            <div class="popup-head">
                <div class="popup-title">选择地区</div>
                <div class="popup-confirm" @click="confirmHandle">确定</div>
            </div>
            <div class="tabs-box" :style="provinceVal.name ? tabStyle : 'width:20%'">
                <van-tabs v-model="activeArea" animated title-inactive-color="#999999" title-active-color="#333333" color="#398DFF" line-width="20" line-height="2" :border="false">
            <van-tab :title="provinceVal.name ? provinceVal.name : '请选择'" name="a">
                <div class="tab-box">
                <div :class="['select-li',provinceVal.id === item.id ? 'active-li' : '']" v-for="item in province" :key="item.id" @click="slectAreaHandle(item)">{{item.name}}<span v-if="provinceVal.id === item.id" class="iconfont active-icon">&#xe615;</span></div>
                </div>
            </van-tab>
            <van-tab v-if="provinceVal.name"  :title="cityVal.name ? cityVal.name : '请选择'" name="b">
                <div class="tab-box">
                <div :class="['select-li',cityVal.id === item.id ? 'active-li' : '']" v-for="item in cityArr" :key="item.id" @click="slectCityHandle(item)">{{item.name}}<span v-if="cityVal.id === item.id" class="iconfont active-icon">&#xe615;</span></div>
                </div>
            </van-tab>
            <van-tab title="请选择" v-if="cityVal.name && areaArr.length>0"  name="c">
                <div class="tab-box">
                <div :class="['select-li',cityChildVal.id === item.id ? 'active-li' : '']" v-for="item in areaArr" :key="item.id" @click="slectCityChildHandle(item)">{{item.name}}<span v-if="cityChildVal.id === item.id" class="iconfont active-icon">&#xe615;</span></div>
                </div>
            </van-tab>
            </van-tabs>
            </div>
        </van-popup>
        <van-popup v-model="isShowCategory" close-icon-position="top-left" position="bottom" :style="`height:${isShowSpace ? '90%' : '100%'} `" :afe-area-inset-bottom="true" >
            <!-- <div v-if="isShowSpace" :style="`height:${navBarHeight}px`"></div> -->
            <div class="category-box">
                <div class="category-title-box">
                    <span @click="closeCateHandle" :style="`top:${navBarHeight}px`" class="iconfont iconlujing2"></span>
            <div class="category-title">选择您所属的领域</div>
                </div>
            <div v-if="cateTagArr.length>0" :class="['select-item-wrap',]">
            <div class="select-item-box" >
                <div class="select-item" v-for="(item) in cateTagArr" :key="item.industryId">{{item.industryName}} <span @click="removeTagHandle(item)" class="iconfont iconxingzhuang8"></span></div>
                <div class="space-block"></div>
            </div>
            <div :class="['selest-count']">已选<span>{{cateTagArr.length}}</span>项</div>
        </div>
        <div v-else class="head-line"></div>
            <div class="category-content">
                <div class="cate-content content-left">
                    <scrollactive :modifyUrl="false"  :offset="isShowSpace ? 70 : 0" class="my-nav" v-on:itemchanged="onItemChanged" scrollContainerSelector=".content-right">
                    <a :href="`#v${index}`" @click="selectItemHandle(index,item)" :class="['scrollactive-item',index===0 ? 'is-active' :'']" v-for=" (item,index) in cateInfoData" :key="item.industryName+index">{{item.industryName}}</a>
                </scrollactive>
                <div style="height:220px"></div>
                </div>
                <div class="cate-content content-right">
                    <ul class="right-con">
                        <li v-for="(val,idx) in cateInfoData" :key="idx+val.industryName">
                            <h3 :id="'v' + idx" class="cate-title">{{val.industryName}}</h3>
                            <p :class="vv.ck ? 'active-select': '' " @click="selecTtagHandle(vv,indx,idx)" v-for="(vv,indx) in val.children" :key="indx+vv.industryName">{{vv.industryName}}<span :class="['iconfont',vv.ck ? 'iconxingzhuang22' : 'iconCombinedShape']"></span></p>
                        </li>
                    </ul>
                    <div style="height:260px"></div>
                </div>
            </div>
            <div class="category-btn-con-box">
                <button class="category-btn-con" @click="categoryConfirm">确定</button>
            </div>
            </div>
        </van-popup>
        <van-popup v-model="isShowDate" closeable close-icon-position="top-left" round position="bottom" :style="{ height: '360px' }" :afe-area-inset-bottom="true">
        <van-datetime-picker
            @confirm="confirmDate"
            @cancel="cancelDate"
            v-model="currentDate"
            cancel-button-text=" "
            :formatter="formatter"
            type="date"
            title="成立日期"
            :min-date="minDate"
            :max-date="maxDate"
            />
        </van-popup>
        <van-popup v-model="isShowHighIndustry" round position="bottom" :style="{ height: '380px' }" :closeable="true" :afe-area-inset-bottom="true">
            <div class="industry-box">
            <h3 class="industry-title">高新技术企业认定</h3>
            
            <div class="industry-btn-box">
                <div class="industry-text">是否在有效期内的国高新资质</div>
                <div class="industry-btn-right">
                <div :class="['industry-btn',industryvalCountry=='1' ? 'active-ndustry' : '']" @click="industryHandle('1')">是</div>
                <div :class="['industry-btn',industryvalCountry=='0' ? 'active-ndustry' : '']" @click="industryHandle('0')">否</div>
                </div>
            </div>
            <button class="industry-btn-con" @click="industryConfirm">确定</button>
            </div>
        </van-popup>
    </div>
</template>
<script>
import { isIPhoneX } from '@/utils/util'
import { registeRarea,companyDictCate } from "@/api/api_company.js"
export default {
    props:{
        params:{
            type:Object,
            required:false,
            default:()=>{
                return {}
            }
        }
    },
    data(){
        return{
            categoryVal:"",
            isIPhoneX:isIPhoneX(),
            activeIcon: require('@/assets/img/companyInfo/checked.png'),
    inactiveIcon:require('@/assets/img/companyInfo/half-checked.png'),
            areaTypeTitle:[],
            isShowCompany:false, //是否显示企业名称下拉框
            isShowRegister:false,//是否显示注册地下拉框
            isShowCategory:false, //是否显示产业类别下拉框
            activeArea:'a', //区域tab标签
            activeCategory:0,//产业类别tab标签
            isShowDate:false,//是否显示成立日期下拉框
            isShowHighIndustry:false,//是否显示高新技术产业下拉框
            isShowCompanyCategory:false, //是否显示企业类别下拉框
            province:[
                {
                    id:'1',name:'北京',chirldren:[{id:'1',name:'北京'}]
                }
            ],
            cityArr:[],
            areaArr:[],
            provinceVal:{},
            cityVal:{},
            cityChildVal:{},
            activeAreaStyle:false,
            categoryArr:['5G/移动通信','物联网','电子信息','5G/移动通信','物联网','电子信息','5G/移动通信','物联网','电子信息'],
            categoryIndx:0,
            minDate: new Date(1945, 0, 1),
            maxDate: new Date(),
            currentDate: new Date(),
            date:'',
            highTechYearCountry:'',
            highTechYearRegion:'',
            industryvalCountry:'0',
            industryvalProvince:'0',
            industryText:'',
            columns: ['事业单位', '法人企业', '社会团体', '个体工商', '其他'],
            areaInfoData:[{
                children:[],
                checkChildValue:[]
            }],
            areaChildren:[],
            checkValueArr:[], //分类
            areaName:'',
            isAreaArr:false,
            tabStyle:'width:40%',
            isHuawei:'',
            cateInfoData:[{
                children:[],
            }],
            cateTagArr:[],
            parentIdx:0,
            offsetHeightpx:0,
            elementLeft:'',
            slideNum:0,
            navBarHeight:0,
            isShowSpace:false
        }
    },
    created(){
        const device_type = navigator.userAgent
        this.isHuawei=device_type.indexOf('ALP-AL00')
    },
    mounted(){
        
        let {foundDate,isHighTechCountry,provinceId,registrationAddr,cityId,regionId}=this.params
    this.date=foundDate
    if(isHighTechCountry===1){
                this.industryText='是'
        }else if(isHighTechCountry===0){
            this.industryText='否'
        }
            this.industryvalCountry=isHighTechCountry &&  String(isHighTechCountry)
            console.log('industryvalCountry',this.industryvalCountry,String(isHighTechCountry))
            this.provinceVal.id=provinceId
    this.areaName=registrationAddr
    if(provinceId === cityId){
        this.cityVal.id=regionId
    }else{
        this.cityVal.id=cityId
        this.cityChildVal.id=regionId
    }
        this.getRegisterArea('province',0)
        this.getAreaInfo()
         if(localStorage.getItem('s') === 'BS'){
              this.isShowSpace=true
            this.navBarHeight =localStorage.getItem('navBarHeight')-44
                console.log('navBarHeight',this.navBarHeight)
          }
     
    },
    methods:{
        closeCateHandle(){
            this.isShowCategory=false
        },
     selecTtagHandle(val,index,parentIdx){
         if(!val.ck){
             let {maxCate}=this.params
          console.log('this.arrayCon',this.cateTagArr)
            if(this.cateTagArr.length>maxCate-1){
                this.$toast(`领域建议${maxCate}个以内，多了不准确`)
                return false;
            }
         }
            console.log('parentIdx',parentIdx)
            this.parentIdx=parentIdx
            this.currentIdxChild=index
            this.cateInfoData[parentIdx].children.forEach((item,idx)=>{
                if(item.industryId===val.industryId){
                    if(!item.ck){
                        this.cateTagArr.push({industryName:val.industryName,industryId:val.industryId,parentIdx:parentIdx})
                    }
                    if(item.ck){
                        this.cateTagArr.forEach((vv,vidx)=>{
                            if(vv.industryId===item.industryId){
                                console.log('splice',idx)
                                this.cateTagArr.splice(vidx,1)
                            }
                        })
                        
                    }
                    this.$set( this.cateInfoData[parentIdx].children[idx],'ck',!item.ck)
                    console.log('cateTagArr',this.cateTagArr)
                }
            })
        },
        removeTagHandle(val){
            this.cateTagArr.forEach((vv,vidx)=>{
                if(vv.industryId===val.industryId){
                    console.log('cateTagArr val',vv)
                    this.cateTagArr.splice(vidx,1)
                    this.cateInfoData[vv.parentIdx].children.forEach((item,idx)=>{
                        if(item.industryId===val.industryId){
                            this.$set( this.cateInfoData[vv.parentIdx].children[idx],'ck',!item.ck)
                        }
                    })
                }
            })
            console.log(' remove cateTagArr',this.cateTagArr)
        },
        selectItemHandle(index,item){
            this.currentIdx=index
            console.log('item',item)
        },
        onItemChanged(event, currentItem){
            this.elementLeft=document.querySelector(`.content-left`)
            this.offsetHeightpx=this.elementLeft.offsetHeight
            // console.log('event',event, 'currentItem',currentItem,'lastActiveItem', lastActiveItem)
            const rect = currentItem.getBoundingClientRect();
            console.log('top',rect.top,'bottom',rect.bottom,'clientHeight',document.documentElement.clientHeight)
            if(rect.top>78){
                let isElementInViewport= this.isElementInViewport(rect,this.offsetHeightpx)
                if(!isElementInViewport){
                this.slideNum=this.slideNum+170
                console.log('向下滚动',this.slideNum)
                this.elementLeft.scrollTop=this.slideNum
                }
                console.log('是否在可视区域向下',isElementInViewport)
            }else if(rect.top<=78){
                let isElementInViewportUp=this.isElementInViewportUp(rect)
                if(isElementInViewportUp){
                    console.log('this.slideNum',this.slideNum)
                    this.slideNum=this.slideNum-170
                    console.log('向上滚动',this.slideNum)
                    this.elementLeft.scrollTop=this.slideNum
                }
                console.log('是否在可视区域向上',isElementInViewportUp)
            }
        },
        isElementInViewport(rect) {
            //获取元素是否在可视区域
            console.log('向下')
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <=
                (window.innerHeight-16 || document.documentElement.clientHeight-16) &&
                rect.right <=
                (window.innerWidth || document.documentElement.clientWidth)
            );
        },
        isElementInViewportUp(rect) {
            //获取元素是否在可视区域
            console.log('向上')
            return (
                rect.top <= 78 &&
                rect.left >= 0 &&
                rect.right <=
                (window.innerWidth || document.documentElement.clientWidth)
            );
        },
        categoryConfirm(){
            if(this.cateTagArr.length===0){
                this.$toast('请至少选择一项领域')
                return false;
            }
            let arrayCon=[]
            let arrayConName=[]
            this.cateTagArr.forEach(element=>{
                arrayCon.push(element.industryId)
                arrayConName.push(element.industryName)
            })
            let {maxCate}=this.params
            if(arrayCon.length>maxCate){
                this.$toast(`领域建议${maxCate}个以内，多了不准确`)
                return false;
            }
            arrayCon=arrayCon.join(',')
            this.params.cateType=arrayCon
            arrayConName=arrayConName.join(',')
            this.categoryVal=arrayConName
            this.isShowCategory=false
            this.$emit('baseInfoForm',this.params)
        },
        //获取所属领域数据
        getAreaInfo(){
            companyDictCate().then(res=>{
                if(res.ok===true){
                    let {data}=res
                    this.cateInfoData=data
                    let arrayConName=[]
                    this.params.cateList.forEach(item=>{
                        arrayConName.push(item.industryName)
                        item.children.forEach(vv=>{
                            this.cateInfoData.forEach((pval,index)=>{
                                if(item.industryId===pval.industryId){
                                    pval.children.forEach((val,idx)=>{
                                    if(vv.industryId===val.industryId){
                                        this.parentIdx=index
                                        this.$set( this.cateInfoData[index].children[idx],'ck',!item.ck)
                                        }
                                    })
                                }
                            })
                            this.cateTagArr.push({industryName:vv.industryName,industryId:vv.industryId,parentIdx:this.parentIdx})
                        })
                    })
                    this.categoryVal=arrayConName.join(',')
                }
            })
        },
        getRegisterArea(type,regionId){
            let params={
                regionId:regionId,
                regionVersion:'1'
            }
            registeRarea(params).then(res=>{
                let that=this
                if(res.ok===true){
                    if(type==='province'){
                        this.province=res.data
                    }else if(type==='city'){
                        this.activeArea='b'
                        this.cityArr=res.data
                    }else{
                        this.areaArr=res.data
                        if(this.areaArr.length>0){
                            this.tabStyle='width:60%'
                            this.cityChildVal.name="请选择"
                            // this.isActiveChild=true
                            setTimeout(()=>{
                                that.activeArea='c'
                            },5)
                            
                        }
                    }
                    
                }
            })
        },
        industryConfirm(){
            this.isShowHighIndustry=false
            if(this.industryvalCountry==='1'){
                this.industryText='是'
            }else{
                this.industryText='否'
            }
            this.params.isHighTechCountry=this.industryvalCountry && parseInt(this.industryvalCountry)
            this.$emit('baseInfoForm',this.params)
        },
        industryHandle(id){
            this.industryvalCountry=id
            this.highTechYearCountry=''
        },
        industryPHandle(id){
            this.industryvalProvince=id
            this.highTechYearRegion=''
        },
        formatter(type, val) {
        if (type === 'year') {
            return `${val}年`;
        } else if (type === 'month') {
            return `${val}月`;
        } else if (type === 'day') {
            return `${val}日`;
        }
        return val;
        },
        confirmDate(value){
            const date=new Date(value)
            const year=date.getFullYear();
            const month=(date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) ;
            const day=date.getDate()<10 ? '0'+(date.getDate()) : date.getDate()
            this.date=year+ '.'+month+ '.'+day
            this.isShowDate=false
            this.params.foundDate=year+'.'+month+'.'+day
            this.$emit('baseInfoForm',this.params)
        },
        cancelDate(){
            this.isShowDate=false
        },
        popupHandle(type){
        if(type==='registerArea'){
                this.isShowRegister=true
            }else if(type==='category'){
                this.isShowCategory=true
            }else if(type==='companyCategory'){
                this.isShowCompanyCategory=true
            }else if(type==='date'){
                this.isShowDate=true
            }else{
                this.isShowHighIndustry=true
            }
        },
        confirmHandle(){
            if(this.cityArr.length>0 && this.cityVal.name==='请选择'){
                this.$toast('请选择城市')
                return false
            }
            if(this.areaArr.length>0 && this.cityChildVal.name==='请选择'){
                this.$toast('请选择区域')
                return false
            }
            this.params.provinceId=this.provinceVal.id
            this.params.cityId=this.cityVal.id
            this.params.regionId=this.cityChildVal.id
            this.$emit('baseInfoForm',this.params)
            if(this.cityVal.name==='请选择'){
                this.areaName=this.provinceVal.name
            }else if(this.provinceVal.name){
                this.areaName=this.provinceVal.name+this.cityVal.name+this.cityChildVal.name
            }
            this.isShowRegister=false
        },
        slectAreaHandle(val){
            this.provinceVal=val
            this.cityVal.name="请选择"
            this.cityVal.id=''
            this.getRegisterArea('city',val.id)
        },
        slectCityHandle(val){
            this.cityVal=val
            this.cityChildVal.name=""
            this.cityChildVal.id=""
            this.getRegisterArea('area',val.id)
            
        },
        slectCityChildHandle(val){
            this.cityChildVal=val
        }
    }
}
</script>
<style lang="less" scoped>
.right-icon{
    position: absolute;
    right: 0;
}
.select-input-arrow{
    position: absolute;
    left: 0;
    width:125px;
    padding-left: 30px;
}
.base-right{
    width:73% !important;
}
.select-box{
    width:35% !important;
    position: absolute;
    right: 0;
}
.right-style{
        width:200px;
    }
.right-style-area{
        width:180px;
    }
.head-line{
    width: 100%;
height: 1px;
background: #DDDDDD;
}
.select-item-wrap{
    height: 50px;
background: #F5F5F5;
position: relative;
.selest-count{
    position:absolute;
    right: 0;
    top:0;
    width: 110px;
height: 50px;
display: flex;
align-items: center;
justify-content: flex-end;
padding-right: 16px;
font-size: 12px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #333333;
line-height: 16px;
background: url('../../assets/img/companyInfo/select-cate-bg.png') no-repeat;
background-size: contain;
span{
    color: #398DFF;
}
}
}
.select-item-box{
    width: 319px;
display: flex;
align-items: center;
padding: 10px 16px;
overflow-x: scroll;
.select-item{
    padding: 8px 12px;
    background: #fff;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 14px;
    border-radius: 17px;
    flex-shrink: 0;
    margin-left: 10px;
}
.space-block{
   flex-shrink: 0;
   width:50px;
   height: 20px; 
}
.iconxingzhuang8{
    color: #CCCCCC;
    font-size: 14px;
}
}
.my-nav{
    width:100%;
    a{
        display: block;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 18px;
        padding: 16px 15px;
        width:100%;
        border: 0;
    }
    .is-active{
        color: #333333;
        background: #fff;
        border: 0;
        border-left: 3px solid rgba(57, 141, 255, 1);
        width:100%;
            border-right: 0;
    }
}
.category-content{
    display: flex;
    flex:1;
    .cate-content{
        max-height: 170vw;
        overflow: scroll;
    }

    .content-left{
        flex-shrink: 0;
        width:90px;     
        background: #F5F5F5;
        text-align: center;
    }
    .content-right{
        padding: 0px 16px 20px;
        .right-con{
            margin-top:-10px
        }
    }
    .right-con{
        li{
            h3{
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 20px;
            padding: 22px 0 20px 0;
            }
            p{
                background: #FFFFFF;
                box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
                border-radius: 3px;
                border: 1px solid #EEEEEE;
                padding: 10px 12px;
                display: inline-block;
                margin:0 16px 14px 0;
                font-size: 13px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 18px;
                .iconCombinedShape{
                    color: #AAAAAA;
                    font-size: 13px;
                    display: inline-block;
                    margin-left: 12px;
                }
            }
            .active-select{
                background: #EBF3FF;
                color: #398DFF;
                .iconCombinedShape{
                    color: #398DFF;
                    
                }
                .iconxingzhuang22{
                    font-size: 12px;
                    display: inline-block;
                margin-left: 12px;
                transform: scale(0.5);
                }
            }
        }
    }
}
/deep/ .van-popup{
    overflow-y: inherit !important;
    overflow: hidden;
}
/deep/ .van-picker__toolbar{
    margin-top:10px;
}
/deep/ .van-picker__title{ 
font-size: 18px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #333333;
line-height: 18px;
margin-left: 25px;
}
/deep/ .van-picker__confirm{  
color: #000000;
}
/deep/ .van-picker__columns{
        margin-top: 30px;
}
.tab-style{
    opacity: 0.5;
}
 /deep/ .van-tabs .van-tabs__wrap{
        padding: 0;
    }

.popup-icon{
    font-size: 60px;
    color: #cccccc;
    display: flex;
    justify-content: center;
    margin: 125px auto 20px;
}
 /deep/ .van-popup__close-icon--top-left{
 top:20px;
}
.company-title{
    font-size:18px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
color:rgba(51,51,51,1);
line-height:14px;
margin-top:25px;
text-align: center;
}
.company-text{
    font-size:12px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(51,51,51,1);
line-height:12px;
text-align: center;
margin-top:73px;
}
.company-btn{
    width:315px;
height:44px;
background:rgba(57,141,255,1);
box-shadow:0px 5px 10px 0px rgba(57,141,255,0.3);
border-radius:22px;
font-size:16px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(255,255,255,1);
line-height:44px;
border: 0;
outline: none;
margin:20px auto 0;
text-align: center;
display: block;
}
.popup-head{
    display: flex;
    justify-content: flex-end;
    margin:20px 15px 0 0;
    font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:@baseBlack;
line-height:14px;
align-items: center;
.popup-title{
    font-size:18px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
color:rgba(51,51,51,1);
line-height:18px;
}
.popup-confirm{
    margin-left: 103px;
}
}
.popup-box{
    overflow: hidden;
}
.tabs-box{
    width:30%;
    margin:35px 0 0 10px;
    /deep/ .van-tabs__content{
        width: 375px;
    }
    /deep/ .van-tabs__wrap{
    margin: 0;
}
    .tab-box{
        padding: 40px 0 0 20px;
        max-height: 393px;
        overflow-x: scroll;
        .select-li{
        font-size:18px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:20px;
        margin-bottom: 28px;
        display: flex;
        align-items: center;
        .active-icon{
            font-size: 12px;
            transform: scale(0.7);
            color: #398DFF;
            display: inline-block;
            margin-left: 10px;
        }
        }
.active-li{
    color: #398DFF;
}
    }
    /deep/ .van-tab{
        font-size: 16px;
    }
}
.tab-label{
    background:rgba(248,248,248,1);
    border-radius:3px;
    width:105px;
height:34px;
    font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(51,51,51,1);
line-height:34px;
display: inline-block;
margin-right: 10px;
margin-bottom: 10px;
text-align: center;
}
.tab-label:nth-child(3n){
    margin-right: 0px;
}
.category-box{
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.category-title-box{
     margin:18px 16px 11px;
    display: flex;
    .iconlujing2{
        font-size: 18px;
        color: rgba(51, 51, 51, 1);
        display: inline-block;
        margin-right: 84px;
        font-weight: 400;
}
.category-title{
    text-align: center;
    font-weight: 500;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    color:#333333;
}
}

.category-btn-con-box{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    padding: 15px 16px;
}
.category-btn-con{
    width:335px;
    height:40px;
    background:rgba(57,141,255,1);
    border-radius:3px;
    font-size:16px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:40px;
    text-align: center;
    margin: 0 auto;
    border: 0;
    outline: none;
    display: block;
}
.ipx-bottom-space{
    height: 20px;
}
.industry-box{
    padding: 0 20px;
}
.industry-title{
    font-size:18px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
color:rgba(51,51,51,1);
line-height:20px;
text-align: center;
margin-top:60px;
}

.industry-btn-box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top:26px;
    margin-top:40px;
    .industry-text{
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:14px;
    
}
    .industry-btn-right{
        width:122px;
        display: flex;
        justify-content: space-between;
    }
    .industry-btn{
        width:57px;
        height:36px;
        background:rgba(248,248,248,1);
        border-radius:3px;
        font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(51,51,51,1);
line-height:36px;
text-align: center;
    }
    .active-ndustry{
    background:rgba(235,243,255,1);
    color: #398DFF;
}
}
.industry-date{
    font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;

line-height:14px;
margin-top:40px;
span{
    color: #FA5151;
}
}
.industry-date-box{
    display: flex;
    justify-content: space-between;
}
.industry-select-box{
    margin-top:26px;
    position: relative;
    width:121px;
    height:40px;
    background:rgba(248,248,248,1);
    border-radius:3px;
    .industry-select-year{
        position: absolute;
        top:0;
        width:100%;
        height: 100%;
        border: 0;
        padding: 0 16px;
        appearance:none;
        outline: none;
        background: transparent;
}
    .industry-select-icon{
        color: #ccc;
        font-size: 10px;
        position: absolute;
        right: 16px;
        top:14px;
        transform: rotate(180deg);
    }
}
.disabled{
    pointer-events:none;
    color: #CCCCCC;
}
.line{
    margin-top:20px;
    width:335px;
    height:1px;
    background:rgba(238,238,238,1);
}

.industry-btn-con{
    width:335px;
height:40px;
background:rgba(57,141,255,1);
border-radius:5px;
font-size:16px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(255,255,255,1);
line-height:40px;
text-align: center;
border:0;
outline: none;
position: absolute;
left: 50%;
transform: translateX(-50%);
bottom: 30px;
}
</style>